var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiketReporting = function SvgTiketReporting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 63.28,
    y1: 188.56,
    x2: 175.28,
    y2: 67.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 49.55,
    y1: 175.86,
    x2: 161.55,
    y2: 54.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 59.4,
    y1: 184.97,
    x2: 171.4,
    y2: 63.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4.94,
    y1: 134.57,
    x2: 116.94,
    y2: 13.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 12.79,
    y1: 141.82,
    x2: 124.79,
    y2: 20.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 45.05,
    y1: 171.69,
    x2: 157.05,
    y2: 50.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 14.89,
    y1: 143.77,
    x2: 126.89,
    y2: 22.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.71,
    y1: 128.41,
    x2: 110.29,
    y2: 7.41,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.33,92.03h2.33c1.29,0,2.33-1.05,2.33-2.33v-9.34c0-5.85-4.33-10.69-9.95-11.53l-7.93-23.4c-1.23-3.64-5.47-5.66-9.08-4.31l-73.89,27.59c-6.21.26-11.19,5.38-11.19,11.65v9.34c0,1.29,1.05,2.33,2.33,2.33h2.33c5.15,0,9.34,4.19,9.34,9.34s-4.19,9.34-9.34,9.34h-2.33c-1.29,0-2.33,1.05-2.33,2.33v9.34c0,6.43,5.24,11.67,11.67,11.67h88.7c6.43,0,11.67-5.24,11.67-11.67v-9.34c0-1.29-1.05-2.33-2.33-2.33h-2.33c-2.49,0-4.84-.97-6.6-2.74-1.76-1.76-2.74-4.11-2.74-6.6,0-5.15,4.19-9.34,9.34-9.34ZM174.67,45.49c1.21-.44,2.62.22,3.03,1.44l7.37,21.76h-72.53l62.13-23.2ZM185.43,111.28c2.64,2.64,6.16,4.1,9.9,4.1h0v7c0,3.86-3.14,7-7,7h-58.36v-2.33c0-1.29-1.05-2.33-2.33-2.33s-2.33,1.05-2.33,2.33v2.33h-25.68c-3.86,0-7-3.14-7-7v-7c7.72,0,14.01-6.28,14.01-14.01s-6.28-14.01-14.01-14.01v-7c0-3.86,3.14-7,7-7h25.68v2.33c0,1.29,1.05,2.33,2.33,2.33s2.33-1.05,2.33-2.33v-2.33h58.36c3.86,0,7,3.14,7,7v7c-7.72,0-14.01,6.28-14.01,14.01,0,3.74,1.46,7.26,4.1,9.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.64,85.21c-1.29,0-2.33,1.05-2.33,2.33v7.9c0,1.29,1.05,2.33,2.33,2.33s2.33-1.05,2.33-2.33v-7.9c0-1.29-1.05-2.33-2.33-2.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.64,104.96c-1.29,0-2.33,1.05-2.33,2.33v7.89c0,1.29,1.05,2.33,2.33,2.33s2.33-1.04,2.33-2.33v-7.9c0-1.29-1.05-2.33-2.33-2.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.69,78.85h38.37c3.29,0,3.29-5.09,0-5.09h-38.37c-3.29,0-3.29,5.09,0,5.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.69,97.5h32.95c3.29,0,3.29-5.09,0-5.09h-32.95c-3.29,0-3.29,5.09,0,5.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.89,164.9h46.65c1.4,0,2.54-1.14,2.54-2.54s-1.14-2.54-2.54-2.54h-1.68v-24.86c0-1.4-1.14-2.54-2.54-2.54h-10.21v-8.96c0-1.4-1.14-2.54-2.54-2.54h-12.72c-1.4,0-2.54,1.14-2.54,2.54v15.48h-10.19c-1.41,0-2.54,1.14-2.54,2.54v18.34h-1.68c-1.4,0-2.54,1.14-2.54,2.54s1.14,2.54,2.54,2.54ZM72.14,137.5h7.63v22.31h-7.63v-22.31ZM59.39,125.99h7.63v33.82h-7.63v-33.82ZM46.66,144.01h7.63v15.8h-7.63v-15.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.46,158.11h-17.59c-3.26,0-5.91,2.65-5.91,5.91v17.7H25.06c-.45,0-.82-.37-.82-.82V37.77c0-.45.37-.82.82-.82h99.58c.45,0,.82.37.82.82v17.36h5.09v-17.36c0-3.26-2.65-5.91-5.91-5.91h-3.67v-3.18c0-3.26-2.65-5.91-5.91-5.91h-3.68v-3.68c0-3.26-2.65-5.91-5.91-5.91H5.91c-3.26,0-5.91,2.65-5.91,5.91v143.13c0,3.26,2.65,5.91,5.91,5.91h3.68v3.68c0,3.26,2.65,5.91,5.9,5.91h3.68v3.18c0,3.26,2.65,5.91,5.91,5.91h79.44c.66,0,1.32-.27,1.79-.74l23.5-23.39c.48-.48.75-1.13.75-1.8v-16.89h-5.09v14.13ZM19.16,37.77v134.88l-3.67-.02c-.45,0-.82-.37-.82-.82V28.69c0-.45.37-.82.82-.82h17.74c3.29,0,3.29-5.09,0-5.09H15.49c-3.26,0-5.91,2.65-5.91,5.91v134.37h-3.68c-.45,0-.82-.37-.82-.82V19.1c0-.45.37-.82.82-.82h99.58c.45,0,.82.37.82.82v3.68h-58.83c-3.29,0-3.29,5.09,0,5.09h67.6c.45,0,.82.37.82.82v3.18H25.06c-3.26,0-5.91,2.65-5.91,5.91ZM107.05,178.1v-14.08c0-.45.37-.82.82-.82h14.02l-14.84,14.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.42,54.37h-49.9c-3.29,0-3.29,5.09,0,5.09h49.9c3.29,0,3.29-5.09,0-5.09Z"
  })));
};
export default SvgTiketReporting;